;(function($, window, document){
    window.Lightbox = Me.view.extend({
        options: {
            currentSlide: 1,
            slideCount: 1,
            lightboxParams: null
        },

        initialize: function() {
            _.bindAll(this, 'displayLightbox', 'closeLightbox', 'keypressHandler', 'prevImage', 'nextImage', 'loadNewImage');
            this.addEvents();
        },
        addEvents: function() {
            Me.dispatch.subscribe('LIGHTBOX.OPEN', this.displayLightbox);
            this.$('.close-button').on('click', this.closeLightbox);

            if(this.$('.arrow-button').length > 0){
                this.$('.arrow-button.left').on('click', this.prevImage);
                this.$('.arrow-button.right').on('click', this.nextImage);
            }

        },
        displayLightbox: function(e, params){
            this.$el.addClass('active');
            $('body').addClass('no-scroll');

            this.options.lightboxParams = params;

            if(params.section){
                if($(params.section).find('[data-lightboxid="' + params.lightboxID + '"]').length > 1){
                    this.$('.arrow-controls').css('display', 'block');
                    this.options.slideCount = $(params.section).find('[data-lightboxid="' + params.lightboxID + '"]').length;
                }else{
                    this.$('.arrow-controls').css('display', 'none');
                }
            }


            this.$('.image-container.current-image img').attr('src', params.lightboxSrc);

            $(window).on('keydown', this.keypressHandler);

        },
        closeLightbox: function(){
            $(window).off('keydown', this.keypressHandler);
            this.$el.removeClass('active');
            $('body').removeClass('no-scroll');

            this.options.lightboxParams = null;
            this.options.currentSlide = 1;
            this.$('.image-container.current-image img').attr('src','');
            this.$('.image-container.next-image img').attr('src','');
        },
        keypressHandler: function(e){
            if(e.keyCode == 27){
                //escape
                this.closeLightbox();
            }
        },
        prevImage: function(e){
            var $currentImg = this.$('.image-container.current-image');
            var $nextImg = this.$('.image-container.next-image');

            $nextImg.removeClass('from-right from right to-left to-right');
            $currentImg.removeClass('from-right from right to-left to-right');

            this.options.currentSlide --;

            if(this.options.currentSlide <= 0){
                this.options.currentSlide = this.options.slideCount;
            }

            $nextImg.addClass('from-left');
            $currentImg.addClass('to-right');

            this.loadNewImage($nextImg);
        },
        nextImage: function(e){
            var $currentImg = this.$('.image-container.current-image');
            var $nextImg = this.$('.image-container.next-image');

            $nextImg.removeClass('from-right from right to-left to-right');
            $currentImg.removeClass('from-right from right to-left to-right');

            this.options.currentSlide ++;

            if(this.options.currentSlide > this.options.slideCount){
                this.options.currentSlide = 1;
            }
            $nextImg.addClass('from-right');
            $currentImg.addClass('to-left');

            this.loadNewImage($nextImg);
        },
        loadNewImage: function(pImgElement){
            var $currentImg = this.$('.image-container.current-image');
            var $nextImg = this.$('.image-container.next-image');

            pImgElement.find('img').attr('src', $(this.options.lightboxParams.section).find('[data-lightboxid="' + this.options.lightboxParams.lightboxID + '"]').eq(this.options.currentSlide-1).attr('data-lightboxsrc'))

            setTimeout(function(){
                $nextImg.addClass('current-image').removeClass('next-image');
                $currentImg.removeClass('current-image').addClass('next-image');
            }, 10);

        }
    });
}(jQuery, window, document));
